import styled from "styled-components";
export const Styles = styled.div`
  .logo {
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    .main-title {
      margin-top: 20px;
      margin-bottom: 10px;
    }
    .main-logo-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      padding: 20px;
      width: 50%;
      @media (max-width:1200px){
        width: 100%;
      }
      border: 1px solid #303030;
      .main-styles-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 60%;
        .title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
    .styles-picker-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
    }
    .font-chooses-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 10px;
      margin-top: 4px;
      justify-content: space-evenly;
      .font-style-container {
        background: #e5edff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 4px;
        border: 1px solid #959595;
        border-radius: 5px;
        padding: 4px;
        width: 100%;
        .font-style {
          font-size: 18px;
          line-height: 24px;
          font-weight: 600;
          color: #474747;
        }
      }
    }
    .colors-container {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-inline-end: 20px;
      .color {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: color;
        cursor: pointer;
        border: 1px #303030 solid;
        transition: border 0.3s ease;
      }
    }
    .final {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      width: 35%;
      height: 200px;
      .final-logo-container {
        background: radial-gradient(circle, #51aafd, #002d68);
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 40px;
        border-radius: 5px;
        width: 100%;
        overflow: hidden;
        .final-logo {
          font-weight: 700;
          line-height: 50px;
        }
      }
    }
  }
`;
